import { render, staticRenderFns } from "./Facetas.vue?vue&type=template&id=3e0573f2&scoped=true"
import script from "./Facetas.vue?vue&type=script&lang=js"
export * from "./Facetas.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=3e0573f2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0573f2",
  null
  
)

export default component.exports